module.exports = __webpack_public_path__ + "static/media/1.e6d20b9f.svg";